/**
 * Wire enum → display label.
 *
 * Every enum value the purchasing contract publishes has an entry in both
 * locales of `./i18n`. Screens resolve them through here so that (a) a raw
 * wire value such as `partially_received` can never reach the UI, and (b) the
 * English default handed to `t()` comes from the same catalogue rather than a
 * second copy drifting inside a component.
 */
import type { TFunction } from "i18next";

import { purchasingMessages } from "./i18n";

const en = purchasingMessages.en.purchasing;

type LabelGroup =
  | "poStatus"
  | "grnStatus"
  | "landedCostStatus"
  | "landedCostType"
  | "landedCostBasis"
  | "reorderStatus"
  | "reorderDismissReason"
  | "transmissionStatus"
  | "transmissionFailure";

export function enumLabel(t: TFunction, group: LabelGroup, value: string): string {
  const fallback = (en[group] as Record<string, string>)[value] ?? value;
  return t(`purchasing.${group}.${value}`, fallback);
}

/** Tolerance scope on the configuration screen (`global` | `category`). */
export function toleranceScopeLabel(t: TFunction, value: string): string {
  const fallback = (en.config.scopeValue as Record<string, string>)[value] ?? value;
  return t(`purchasing.config.scopeValue.${value}`, fallback);
}
